import React from 'react';
import Icons from '../../../../../../components/Common/Icons/Icons';
import { useMessageManagerProvider } from '../../../../../context/messageManager';
import { cn } from '../../../../../../utils/styles';
import Statement from './Tabs/Statement';
import EndOfStatement from './Tabs/EndOfStatement';

export function Empty({ placeholder }: { placeholder?: string }) {
  return (
    <div className="text-center uppercase grid self-center">
      {placeholder ? (
        <>
          <Icons.Image className="mb-[5px] opacity-20 mx-auto" />
          <div className="opacity-60 font-medium">{placeholder}</div>
        </>
      ) : null}
    </div>
  );
}

Empty.defaultProps = {
  placeholder: '',
};

function BuilderStepTwo() {
  const { activeTab } = useMessageManagerProvider();

  return (
    <div className="grid">
      <div className={cn({ hidden: activeTab !== 0 })}>
        <Statement />
      </div>
      <div className={cn({ hidden: activeTab !== 1 })}>
        <EndOfStatement />
      </div>
    </div>
  );
}

export default BuilderStepTwo;
